var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OfflineError, ServerError } from "@core/api/errors";
var TCApi = /** @class */ (function () {
    function TCApi() {
    }
    TCApi.prototype.call = function (method, options) {
        // Options
        var backend = options != null && options.backend != null ? options.backend : TCApi.DefaultBackend;
        var authToken = options != null && options.authToken != null ? options.authToken : undefined;
        var args = options != null && options.data != null ? options.data : {};
        // Derived options
        var url = "/internal/api/".concat(backend, "/?_=").concat(Date.now());
        var data = JSON.stringify({ method: method, args: args });
        var headers = __assign({ 'X-Requested-With': 'XMLHttpRequest' }, authToken != null && { 'X-TC-TOKEN': authToken });
        return fetch(url, {
            body: data,
            method: 'POST',
            headers: headers,
            credentials: 'same-origin'
        }).then(function (response) {
            if (response.status != 200) {
                var error_1 = "Unsupported status code ".concat(response.status, " (expected 200)");
                console.error("[TCApi]: ".concat(error_1));
                return response.json().then(function (json) {
                    throw new ServerError(response.status, error_1, json);
                });
            }
            return response.json();
        }, function (error) {
            console.error('[TCApi]: Fetch failed. Server could not be reached, probably offline.', {
                url: url,
                data: data,
                headers: headers,
                error: error
            });
            throw new OfflineError();
        });
    };
    TCApi.prototype.public = function (method, options) {
        options = options != null ? options : {};
        options.backend = 'public';
        return this.call(method, options);
    };
    TCApi.prototype.private = function (method, options) {
        options = options != null ? options : {};
        options.backend = 'private';
        return this.call(method, options);
    };
    TCApi.DefaultBackend = 'private';
    return TCApi;
}());
export { TCApi };
